import { cn } from '@/lib/utils'

export function CategoryChip({
  label,
  active,
  onClick,
}: {
  label: string
  active?: boolean
  onClick?: () => void
}) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'shrink-0 inline-flex items-center px-4 py-2 rounded-xl border text-sm',
        'transition-colors',
        active
          ? 'bg-primary/10 text-primary border-primary/30'
          : 'hover:bg-muted'
      )}
      title={label}
    >
      {label}
    </button>
  )
}
